import classNames from "classnames";
import React from "react";
import { SkeletonContainer } from "../Skeleton/Skeleton";

// import Styles from "./Text.module.scss";

export enum Elements {
  "h1" = "h1",
  "h2" = "h2",
  "h3" = "h3",
  "h4" = "h4",
  "p" = "p",
  "span" = "span",
  "label" = "label",
}

export enum Sizes {
  "xs" = "xs",
  "s" = "s",
  "sm" = "sm",
  "m" = "m",
  "md" = "md",
  "l" = "l",
  "lg" = "lg",
  "xl" = "xl",
  "2xl" = "2xl",
}

export const SizesMapping = {
  [Sizes.xs]: 14,
  [Sizes.s]: 16,
  [Sizes.sm]: 18,
  [Sizes.m]: 20,
  [Sizes.md]: 22,
  [Sizes.l]: 28,
  [Sizes.lg]: 36,
  [Sizes.xl]: 54,
  [Sizes["2xl"]]: 72,
};

export const LineHeightMapping = {
  [Sizes.xs]: 18,
  [Sizes.s]: 22,
  [Sizes.sm]: 24,
  [Sizes.m]: 28,
  [Sizes.md]: 22,
  [Sizes.l]: 28,
  [Sizes.lg]: 36,
  [Sizes.xl]: 54,
  [Sizes["2xl"]]: 72,
};

interface Props {
  as: Elements;
  size: Sizes;
  fontWeight?: string | number;
  className?: string;
  lineHeight?: string | number;
  children:
    | undefined
    | string
    | number
    | null
    | TemplateStringsArray
    | JSX.Element
    | Array<string | null | JSX.Element>;
  skeleton?: {
    show?: boolean;
    className?: string;
    style?: React.CSSProperties;
  };
  title?: string;
}

const Text = ({ as, size = Sizes.s, fontWeight = 400, className, lineHeight, children, skeleton, title }: Props) => {
  const fontSize = SizesMapping[size];
  const lineHeightVar = lineHeight ? lineHeight : LineHeightMapping[size];
  const Component = React.createElement(
    as,
    { title, className, style: { fontSize: `${fontSize}px`, fontWeight, lineHeight: `${lineHeightVar}px` } },
    children
  );

  return (
    <SkeletonContainer
      show={skeleton?.show}
      style={{ height: `${fontSize}px`, ...skeleton?.style }}
      className={classNames(skeleton?.className, className)}
    >
      {Component}
    </SkeletonContainer>
  );
};

export default Text;
